import $models from '@/models'
// import $store from '@/store'
import util from '@/util'
import firebase from "@firebase/app";

const $sequence = $models.sequence;
const $userSequenceSettings = $models.userSequenceSettings;

export function sequence_share_with_friend({ sequence_id, user_id }) {

  console.log("sequence_invite", sequence_id, user_id);

  if ( !util.isValidId( sequence_id ) ) {
    throw new Error('Invalid sequence_id', sequence_id)
  }

  if ( !util.isValidId( user_id ) ) {
    throw new Error('Invalid user_id', user_id)
  }

  if ( user_id === $models.user.defaultUserId ) {
    throw new Error('Can not invite yourself')
  }

  let sequence_model = $sequence.getNode( sequence_id );
  return sequence_model.$promise.then(() => {

    let promiseUpdateSeq = $sequence.update( sequence_id, {
      ['viewers/' + user_id]: true // TODO: also allow false (view only)
    })

    let current_user = firebase.auth().currentUser;
    // let senderUserData = $store.getters["user/userData"];
    // let displayName =  senderUserData.firstName + ' ' + senderUserData.lastName;
    let sender = {
      name: current_user.displayName,
      uid:  current_user.uid,
      url:  $models.userSettings.getters.get_profile_pic, // $store.getters['user/get_profile_pic'],
    }

    let invitation = $userSequenceSettings
      .with({ uid: user_id })
      .new_from_template({ cachedName: sequence_model.name }, { sender })

    invitation.$id = sequence_id; /* overwrite id */
    let promiseSendInvitation = invitation.write();

    return Promise.all([promiseUpdateSeq, promiseSendInvitation]);
  })
}

export function sequence_revoke({ sequence_id, user_id }) {

  if ( !util.isValidId( sequence_id ) ) {
    throw new Error('Invalid sequence_id', sequence_id)
  }

  if ( !util.isValidId( user_id ) ) {
    throw new Error('Invalid user_id', user_id)
  }

  let promiseUpdateSeq = $sequence.update( sequence_id, {
    ['viewers/' + user_id]: null
  })

  let promiseUninivite = $userSequenceSettings.with({ uid: user_id }).remove( sequence_id )

  return Promise.all([ promiseUpdateSeq, promiseUninivite ]);
}
